export default "__VITE_ASSET__BO1$31ol__"